import { render, staticRenderFns } from "./CodeAnalyzerDescript.vue?vue&type=template&id=6f6b3b5a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports